import React from "react";
import PropTypes from "prop-types";

export const Card = ({
    content,
}) => {
    return (
        <div className="card-container" data-testid="card-container-div">
            <div className="card-content">
                <div className="card-body">
                    <div className="card-description" data-testid="card-description-div">
                        <div>{content}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Card.propTypes = {
    content: PropTypes.string,
};